module.exports = __webpack_public_path__ + "nucleo-outline.22a0bffe789c286a9d78.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/assets/fonts/nucleo-outline.ttf
// module id = ../../../../../src/assets/fonts/nucleo-outline.ttf
// module chunks = 17